import { CalendarClock } from "lucide-react";

type StockClosingHeaderProps = {
  title: string;
  status: React.ReactNode;
  actions: React.ReactNode;
};

export function StockClosingHeader({
  title,
  status,
  actions,
}: StockClosingHeaderProps) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between p-3 md:p-4">
      <div className="flex items-start gap-2 md:gap-3 min-w-0 flex-1">
        <div className="h-9 w-9 md:h-10 md:w-10 rounded-lg md:rounded-xl bg-slate-100 flex items-center justify-center shrink-0">
          <CalendarClock className="h-4 w-4 md:h-5 md:w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-sm md:text-base lg:text-lg font-semibold truncate mb-1 md:mb-0">
            {title}
          </h2>
          {status}
        </div>
      </div>
      <div className="w-full md:w-auto">
        {actions}
      </div>
    </div>
  );
}
